import { render, staticRenderFns } from "./PayoutsCard.vue?vue&type=template&id=1d8f07a1&scoped=true&"
import script from "./PayoutsCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PayoutsCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PayoutsCard.vue?vue&type=style&index=0&id=1d8f07a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f07a1",
  null
  
)

export default component.exports